import React from "react";

type UseRemoveAttributeParams = {
  selector: string;
  attribute: string;
  root?: Document | HTMLElement;
};

const useRemoveAttribute = (
  params: UseRemoveAttributeParams | UseRemoveAttributeParams[]
) => {
  React.useLayoutEffect(() => {
    const items = Array.isArray(params) ? params : [params];

    items.forEach(({ selector, attribute, root = document }) => {
      const element = root.querySelector(selector);
      if (element) {
        element.removeAttribute(attribute);
      }
    });
  }, [params]);
};

export default useRemoveAttribute;
